import React from 'react';

const Icon = ({ size = '48', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" {...other}>
            <path
                d="M38.524 7.124s4.877 6.689-3 16.5c-4.416 5.5-17.186 9.5-11 18 4.814 5.5 9.5-1 12-8.5s8.604-12.037 7.526-19.347c-1.079-7.309-7.7-12.321-19.84-8.413-12.141 3.91-19.686 16.26-20.186 22.26-.542 6.5 8.14 8.523 11 2.5 2.862-6.025-1.944-11.47 7.575-18.184 9.52-6.714 14.427-3.512 15.925-2.316"
                stroke="white"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M11.914 28.265c.782-1.709.415-3.552-.82-4.118-1.236-.565-2.872.362-3.654 2.071-.782 1.71-.415 3.553.82 4.118 1.236.566 2.872-.361 3.654-2.07Z"
                stroke="white"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export default React.memo(Icon);
